export class StaticMemory {
  public static xRoute = '&T(%^&IYU6756856iyku,gKYUGL>IUH' + window.location.hostname;
  public static isAuthVerified: boolean = false;
  public static isServiceArea: boolean = false;
  public static addressObject: any = {};
  public static serAreaObject: any = {};
  public static businessProfileObject: any = {};
  public static walletBalance: number = 0;
  public static menuHidden: boolean = false;
  public static profileDetails: any = {};

  public static onCashBackOfferCalculation(data: any, gTotal: number) {
    let currentOffer = null;
    let nextOffer = null;
    data.forEach((offer: any) => {
      if (offer.invoiceValue <= gTotal) {
        if (!currentOffer || offer.invoiceValue > currentOffer.invoiceValue) {
          currentOffer = offer;
        }
      } else if (!nextOffer || offer.invoiceValue < nextOffer.invoiceValue) {
        nextOffer = offer;
      }
    });
    const remaining = nextOffer ? nextOffer.invoiceValue - gTotal : null;
    return {
      currentOffer,
      nextOffer,
      remaining: remaining && remaining > 0 ? remaining : null,
    };
  }
}
